import { createContext } from '@chakra-ui/react-utils';

import { PortalProps } from '@frontend/components';

import type { OnReorderParams } from '../types';

type SortableListContext<Item = unknown> = {
  orderedItems: Item[];
  onLocalReorder: ({ oldIndex, newIndex }: OnReorderParams) => void;
  onReorderFinished: ({ oldIndex, newIndex }: OnReorderParams) => void;
  onReorderStart?: ({ index }: { index: number }) => void;
  containerRef?: PortalProps['containerRef'];
};

const [SortableListContextProvider, useSortableListContextUnTyped] =
  createContext<SortableListContext>({
    name: 'SortableListContext',
    errorMessage:
      'useSortableListContext: `context` is undefined. Seems you used the useSortableListContext hook outside of a SortableListContextProvider. One way this can happen is by using the useSortableItem hook outside of a SortableListProvider.',
  });

const useSortableListContext = useSortableListContextUnTyped as <
  Item = unknown,
>() => SortableListContext<Item>;

export { SortableListContextProvider, useSortableListContext };
